import { toast } from 'sonner';
import { apiFetch } from '@/lib/api';

/**
 * Email a purchase order's PDF to its supplier, then surface the outcome as a toast.
 *
 * Called immediately after a PO is sent / marked-sent. The empty body makes the server fall back to
 * the supplier's email on file (and default subject/message). This NEVER throws: the PO has already
 * been committed as "sent", so an email failure must only warn — it must not roll back the status or
 * break the calling flow.
 */
export async function emailPoToSupplier(poId: number | string): Promise<void> {
  try {
    await apiFetch(`/api/purchase-orders/${poId}/email`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
    toast.success('Purchase order sent and emailed to the supplier');
  } catch (err) {
    const m = err instanceof Error ? err.message : 'Email failed';
    if (/no recipient email/i.test(m)) {
      toast.warning(
        'Purchase order sent — add an email to this supplier to email it automatically.',
      );
    } else if (/smtp not configured/i.test(m)) {
      toast.warning('Purchase order sent, but email isn’t configured (Settings → Email).');
    } else {
      toast.warning(`Purchase order sent, but emailing failed: ${m}`);
    }
  }
}
